/**
 * POS Actions when check viewing table.
 */
export enum PosActionNameEnum {
  SEND_TO_TABLE = 'SEND_TO_TABLE',
  SEND_TO_TABLE_AND_PAY = 'SEND_TO_TABLE_AND_PAY',
  SEND_TO_TABLE_AND_STAY = 'SEND_TO_TABLE_AND_STAY',
  SEND_ORDER_NOTE_OPTIONS_TO_TABLE = 'SEND_ORDER_NOTE_OPTIONS_TO_TABLE',
  LOAD_DISCOUNT_TYPE_TABLE = 'LOAD_DISCOUNT_TYPE_TABLE',
  LOAD_SERVICE_CHARGE_TABLE = 'LOAD_SERVICE_CHARGE_TABLE',
  VOID_PRODUCTS = 'VOID_PRODUCTS',
  SHOW_MOVE_TABLE_MODAL = 'SHOW_MOVE_TABLE_MODAL',
  CLOSE_TABLE = 'CLOSE_TABLE',
  CHECK_FOR_UNPAID_POS_CART = 'CHECK_FOR_UNPAID_POS_CART',
  CREATE_POS_GUEST_ORDER = 'CREATE_POS_GUEST_ORDER',
  REORDER_PRODUCTS_TO_SALE_UNIT_CART = 'REORDER_PRODUCTS_TO_SALE_UNIT_CART',
  VOID_PRODUCTS_ON_SPLIT_TABLE = 'VOID_PRODUCTS_ON_SPLIT_TABLE',
  SHOW_TABLE_TAG_DIALOG = 'SHOW_TABLE_TAG_DIALOG',
  CREATE_POS_CART_PARTIAL_PAYMENT = 'CREATE_POS_CART_PARTIAL_PAYMENT',
  NAVIGATE_TO_CHECKOUT = 'NAVIGATE_TO_CHECKOUT',
  QUICK_PAY_POS_ORDER_FROM_AGE_VERIFICATION = 'QUICK_PAY_POS_ORDER_FROM_AGE_VERIFICATION',
  SEND_TO_TABLE_FROM_AGE_VERIFICATION = 'SEND_TO_TABLE_FROM_AGE_VERIFICATION',
  SEND_AND_PAY_FROM_AGE_VERIFICATION = 'SEND_AND_PAY_FROM_AGE_VERIFICATION',
  SEND_AND_STAY_FROM_AGE_VERIFICATION = 'SEND_AND_STAY_FROM_AGE_VERIFICATION',
  OPEN_VOUCHER_CODE_TABLE = 'OPEN_VOUCHER_CODE_TABLE'
}
